const courses = {
	title: "Courses",
	longrun_title: "Longrun course",
	new_course: "New Course",
	new_longrun_course: "New longrun course",
	edit_course: "Edit Course: {name}",
	edit_longrun_course: "Edit longrun course: {name}",
	view_course: "View Course: {name}",
	list_title: "List of Courses",
	list_subtitle: "Manage Course",
	create_title: "Create New Course",
	update_title: "Update Course",
	address_title: "Address",
	details_title: "Course Details",
	id: "ID",
	name: "Name",
	short_description: "Practical info for registration form",
	description: "Expertise description ( Visible on enrollemnt form too)",
	instructor_id: "Instructor",
	start_datetime: "Start",
	start_date: "Start Date",
	start_time: "Start Time",
	end_datetime: "End",
	end_date: "End Date",
	end_time: "End Time",
	price: "Price",
	location: "Location",
	type: "Course Type",
	num_places: "Sits qty",
	num_enrolled: "Enrolled",
	num_enrolled_attendees: "Attendees",
	send_email_notification: "Email notification",
	send_sms_notification: "SMS notification",
	status: "Status",
	is_published: "Published?",
	is_published_helptext: "Check this box to make this course available in course list for public enrolment",
	created_by: "Created By",
	register_link: "Reg Form",
	number_of_days: "Number of Days",
	upload_image: "Upload Image",
	select_image: "Select image to upload",
	upload_document: "Upload Document",
	select_document: "Select document to upload",
	no_image_selected: "No image selected",
	no_document_selected: "No document selected",
	all: "All",
	course_popup_title: "Select course for enrollment of {length} selected student(s)",
	filter_course: "Filter course",
	no_course_selected: "No course selected",
	attendance_list: "Register Attendees",
	attendance: "Attendance",
	cancel_course: "Cancel Course",
	cancelcourse_message: "Are you sure you want to cancel this course?",
	cancelcourse_success: "Course successfully cancelled",
	show_requests_only: "Show requests",
	select_requests_only: "Select from Requests",
	select_students: "Select from Students",
	course_list: "Webview",
	quick_filter: "Quick Filter",
	course_date_change_notification: "Changes made to a course will trigger an email notification. Please select below.",
	attendee_remove_back_enrolment: "Would you like to move participant back to enrollment?",
	attendee_remove: "Participant will be deleted as participant. Would you like to proceed?",
	cant_find_course: "Can't find a course. Register your interest here.",
	delete_enrolment: "Delete enrollment",
	move_enrolment: "Would you like to move enrolled to Interested list or enroll to another course?",
	move_enrolment_interested_list: "Interested list",
	move_enrolment_another_course: "Enroll to course",
	move_enrolment_interested_list_success: "Enrolment successfully moved back to interested list.",
	move_enrolment_interested_list_failed: "Failed to moved the enrolment to interested list",
	move_enrolment_another_course_success: "Enrolment successfully moved back to another course.",
	move_enrolment_another_course_failed: "Failed to moved the enrolment to another course.",
	register_attendance: "Register attendance",
	register_attendance_helper: "Will activate registration of daily attendance if checked",
	course_dates: "Course dates",
	course_descriptions: "Course description",
	enrolment_due_date: "Enrolment due date",
	exclude_weekends: "Exclude weekends",
	overbooked_tooltip: "Course is overbooked. Requires attention.",
	allow_overbook: "Allow to overbook",
	allow_overbook_helptext: "Checking this box will allow students to enroll to courses even if they are full. Students will be visible in enrolled list at this course",
	allow_reservation: "Allow reservations",
	allow_reservation_helptext: "When activated, Companies will be able to reserve spots at the course without entering the student data.",
	course_documents: "Course documents",
	certificate_valid_until: "Certificate valid until",
	certificate_valid_until_helptext: "Calculated based on the number of months set in the used template",
	expired: "Expired",
	valid_until: "Valid until",
	adjust_time_per_day: "Adjust start/end time per day",
	adjust_time_per_day_confirm: "Changes made to daily start/end time will be lost. Do you want to continue?",
	certificate_issued_date: "Issued date",
	date_text_clps: "{day} day(s) with start on {date}",
	organisation: "Organisation",
	update_comment: "Update comment",
	comment: "Comment",
	stand_in: "Stand In",
	move_attendee_message: "What would you like to do?",
	delete_attendee: "Delete as attendee",
	move_attendee_another_course: "Enroll to another course",
	move_attendee_interested_list: "Move to interested list",
	move_attendee_interested_list_success: "Attendee successfully moved back to interested list.",
	move_attendee_interested_list_failed: "Failed to moved the attendee to interested list",
	move_attendee_another_course_success: "Attendee successfully moved back to another course.",
	move_attendee_another_course_failed: "Failed to moved the attendee to another course.",
	upcoming_course: "Upcoming courses",
	dates_not_set: "Course dates are not set",
	move_course_diff_template: "The course template for destination course is different from the original course. All additional choices will be removed. Would you like to proceed?",
	company_internal: "Company-internal",
	company_internal_course: "Company-internal courses",
	company_internal_select: "Company-internal training. Select company.",
};
export default courses;